'use client'

import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { RETURNS_HELP_LINK } from 'refunds/constants/constants'

import text from 'fukku/styles/texts.module.scss'
import style from './NoPurchasesMessage.module.scss'

export function NoPurchasesMessage() {
	const { t } = useLabels()
	const { enabled: isNewHelpEnabled } = useFeatureFlag(featureFlagKeys.HelpPage)
	const { isApp } = useMasterData()

	// TODO: Remove when new Help is enabled in the app
	if (isApp) {
		return null
	}

	const linkHelpPlaceholders = {
		refunds: RETURNS_HELP_LINK,
	}

	return (
		<div data-testid='myRefunds.noPurchase.message' className={style.container}>
			<span className={text.bodyM}>
				<ClientLabel
					placeholderValues={linkHelpPlaceholders}
					linkProps={{
						className: style.link,
						withLegacyLocale: !isNewHelpEnabled,
					}}
					paragraphProps={{ className: style.content }}
				>
					{t('myRefunds.withoutPurchases.bodycopy')}
				</ClientLabel>
			</span>
		</div>
	)
}
